import { render, staticRenderFns } from "./PasswordUpdateForm.vue?vue&type=template&id=9506ec74"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9506ec74')) {
      api.createRecord('9506ec74', component.options)
    } else {
      api.reload('9506ec74', component.options)
    }
    module.hot.accept("./PasswordUpdateForm.vue?vue&type=template&id=9506ec74", function () {
      api.rerender('9506ec74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/PasswordUpdateForm.vue"
export default component.exports